import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import * as Yup from "yup"
import { useFormik } from "formik"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import "../System-Configuration/main.scss"

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle"

import { addApiConfiguration, editApiConfiguration, getOneApiConfiguration } from "../../../http/UAM/apiConfig.helper";
import CommonDialog from "components/Common/CommonDialog"
import { useToast } from "ToastStore"
import { decryptedValue } from "common/utility"

const AddApiConfiguration = props => {
  const navigate = useNavigate()

  const location = useLocation()
  const pathnameSegments = location.pathname.split("/")
  const lastSegment = pathnameSegments[pathnameSegments.length - 1]

  document.title = `${lastSegment.toUpperCase()} Api Configuration | FundLync`

  const urlParams = new URLSearchParams(window.location.search)
  const encodedId = urlParams.get("id")
  const decodedId = atob(encodedId)

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [apiConfigList, setApiConfigList] = useState({})
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(true);

  const { handleToastData } = useToast();
  const user = decryptedValue(localStorage.getItem("user"));

  useEffect(() => {
    if (lastSegment == "view" || lastSegment == "edit") {
      getOneApiConfiguration({ apiConfigId: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            setApiConfigList(responseFromAPI.data)
          }
        })
        .catch(error => { })
    }

    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }
  }, [])


  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      url: apiConfigList.url || "",
      purpose: apiConfigList.purpose || "",
      apiUsername: apiConfigList.apiUsername || "",
      apiPassword: apiConfigList.apiPassword || "",
      apiPort: apiConfigList.apiPort || "",
      apiShortCode: apiConfigList.apiShortCode || "",
      keyValues: apiConfigList.keyValues || "",
      source: apiConfigList.source || ""
    },
    validationSchema: Yup.object({
      url: Yup.string().required("URL is Required"),
      purpose: Yup.string().required("Please Enter Purpose"),
      apiUsername: Yup.string().required("Please Enter Username"),
      apiPassword: Yup.string().required("Please Enter Api Password"),
    }),
    onSubmit: values => {
      const message = lastSegment == 'edit' ? 'Are you sure want to update API Configuration?' : 'Are you sure want to add API Configuration?'
      setShowCommonDialog({ isShow: true, message: message })

    },
  })

  const navigateBack = () => {
    navigate(-1)
  }


  const submiTemplates = () => {
    const { values } = validation
    if (lastSegment == "edit") {
      const updateTemplate = {
        id: decodedId,
        url: values.url,
        purpose: values.purpose,
        apiShortCode: values.apiShortCode || null,
        apiUsername: values.apiUsername,
        apiPassword: values.apiPassword,
        apiPort: values.apiPort || null,
        keyValues: values.keyValues || null,
        source: values.source || null
      }
      // update permission
      editApiConfiguration(updateTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            handleToastData(responseFromAPI.message, "success")
            navigate(`/${user.roleName}/api-config`);
          }
        })
        .catch(error => { })
      validation.resetForm()
    } else {
      const newTemplate = {
        url: values.url,
        purpose: values.purpose,
        apiShortCode: values.apiShortCode || null,
        apiUsername: values.apiUsername,
        apiPassword: values.apiPassword,
        apiPort: values.apiPort || null,
        keyValues: values.keyValues || null,
        source: values.source || null
      }
      addApiConfiguration(newTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            handleToastData(responseFromAPI.message, "success")
            navigate(`/${user.roleName}/api-config`);
          }
        })
        .catch(error => { })
      validation.resetForm()
    }
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      submiTemplates()
    } else {
      setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={`${lastSegment.toUpperCase()} API CONFIGURATION`}
          />
          <Row className="vertical-scroll">
            <Col xs="12">
              <div>
                <div>
                  {showEditTemplate && <form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          URL *
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="url"
                          id="horizontal-url-Input"
                          placeholder="Enter URL"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.url || ""}
                          invalid={
                            validation.touched.url &&
                            validation.errors.url
                          }
                        />
                        {validation.touched.url &&
                          validation.errors.url ? (
                          <FormFeedback type="invalid">
                            {validation.errors.url}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Purpose *
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="purpose"
                          id="horizontal-email-Input"
                          placeholder="Enter Purpose "
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.purpose || ""}
                          invalid={
                            validation.touched.purpose &&
                            validation.errors.purpose
                          }
                        />
                        {validation.touched.purpose &&
                          validation.errors.purpose ? (
                          <FormFeedback type="invalid">
                            {validation.errors.purpose}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          API UserName *
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="apiUsername"
                          id="horizontal-url-Input"
                          placeholder="Enter Api Username"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.apiUsername || ""}
                          invalid={
                            validation.touched.apiUsername &&
                            validation.errors.apiUsername
                          }
                        />
                        {validation.touched.apiUsername &&
                          validation.errors.apiUsername ? (
                          <FormFeedback type="invalid">
                            {validation.errors.apiUsername}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label"
                        >
                          API Password *
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="apiPassword"
                          id="horizontal-email-Input"
                          placeholder="Enter Api Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.apiPassword || ""}
                          invalid={
                            validation.touched.apiPassword &&
                            validation.errors.apiPassword
                          }
                        />
                        {validation.touched.apiPassword &&
                          validation.errors.apiPassword ? (
                          <FormFeedback type="invalid">
                            {validation.errors.apiPassword}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          API Port
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="apiPort"
                          id="horizontal-url-Input"
                          placeholder="Enter Api Port"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.apiPort || ""}
                        />
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label"
                        >
                          API ShortCode
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="apiShortCode"
                          id="horizontal-email-Input"
                          placeholder="Enter Api ShortCode "
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.apiShortCode || ""}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Key Values
                        </Label>
                        <Input
                          type="textarea"
                          className="form-control"
                          name="keyValues"
                          id="horizontal-url-Input"
                          placeholder="Enter Key Values"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.keyValues || ""}
                        />
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Source
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="source"
                          id="horizontal-email-Input"
                          placeholder="Enter Source "
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.source || ""}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="text-end">
                          <button
                            className="btn btn-outline-success save-customer me-3"
                            onClick={navigateBack}
                          >
                            Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </form>}

                  {showViewTemplate && <div>
                    <Row className="mb-4">
                      <Col sm={5}>
                        <Label
                          className="col-sm-3 col-form-label label"
                        >
                          URL *
                        </Label>
                        <p className="fs-5">{apiConfigList.url || "-"}</p>
                      </Col>
                      <Col sm={5}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label label"
                        >
                          Purpose *
                        </Label>
                        <p className="fs-5">{apiConfigList.purpose || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={5}>
                        <Label
                          className="col-sm-3 col-form-label label"
                        >
                          API UserName *
                        </Label>
                        <p className="fs-5">{apiConfigList.apiUsername || "-"}</p>
                      </Col>
                      <Col sm={5}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label label"
                        >
                          API Password *
                        </Label>
                        <p className="fs-5">{apiConfigList.apiPassword || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={5}>
                        <Label
                          className="col-sm-3 col-form-label label"
                        >
                          API Port
                        </Label>
                        <p className="fs-5">{apiConfigList.apiPort || "-"}</p>
                      </Col>
                      <Col sm={5}>
                        <Label
                          className="col-sm-3 col-form-label label"
                        >
                          API ShortCode
                        </Label>
                        <p className="fs-5">{apiConfigList.apiShortCode || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={5}>
                        <Label
                          className="col-sm-3 col-form-label label"
                        >
                          Key Values
                        </Label>
                        <p className="fs-5">{apiConfigList.keyValues || "-"}</p>
                      </Col>
                      <Col sm={5}>
                        <Label
                          className="col-sm-3 col-form-label label"
                        >
                          Source
                        </Label>
                        <p className="fs-5">{apiConfigList.source || "-"}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div>
                          <button
                            className="btn btn-outline-success"
                            onClick={() => {
                              navigateBack()
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
    </React.Fragment>
  )
}

AddApiConfiguration.propTypes = {
  history: PropTypes.object,
}

export default AddApiConfiguration
